import type { Dispatch } from '@reduxjs/toolkit';
import {
    freemiumTrialTariffId,
    isControlFreemium,
    isHardFreemium,
    isSoftFreemium,
} from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { BillingActions } from 'reactApp/modules/billing/billing.module';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { sendGa, sendXray } from 'reactApp/utils/ga';
import opener from 'reactApp/utils/opener';

const FAMILY_FOLDERS_PATH = '/family/folders';

export const createFreemiumModalOpenHandler = (dispatch: Dispatch, paySource?: string) => () => {
    if (isSoftFreemium) {
        dispatch(BillingActions.getFreemium());
        setTimeout(() => {
            opener(FAMILY_FOLDERS_PATH, true);
        }, 500);
        return;
    }
    if (isControlFreemium) {
        dispatch(
            openTariffBuy({
                productId: freemiumTrialTariffId,
                onSuccess: () => {
                    sendGa('success');
                    sendXray(['freemium', 'trial', 'buy', 'success']);
                    setTimeout(() => {
                        opener(FAMILY_FOLDERS_PATH, true);
                    }, 500);
                },
                paySource: paySource || 'family_unlimited_trial',
            })
        );
        return;
    }
    if (isHardFreemium) {
        opener(FAMILY_FOLDERS_PATH, true);
        return;
    }
};
